import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

dayjs.extend(utc);
dayjs.extend(timezone);

interface TimeComponentProps {
  position?: 'bottom-left' | 'top-left' | 'top-right' | 'above-suggestions' | 'custom';
}

export default function TimeComponent({}: TimeComponentProps) {
  const [searchParams] = useSearchParams();
  const forTutorManager = searchParams.get('forTM')?.toLowerCase() === 'true';

  const timeFormat = 'HH:mm:ss:SSS';

  const getCurrentIST = () => {
    const now = dayjs.tz(new Date(), 'Asia/Kolkata');
    return {
      date: now.format('ddd, MMM D, YYYY'),
      time: now.format(timeFormat),
    };
  };

  const [currentTimeStr, setCurrentTime] = useState(getCurrentIST);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getCurrentIST);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Style for better visibility over slides
  const timeStyles = {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    padding: '8px 16px',
    borderRadius: '8px',
    backdropFilter: 'blur(4px)',
    color: 'white',
    fontSize: '14px',
    fontWeight: '500',
    // Override the CSS fixed positioning
    position: 'static' as const,
    bottom: 'auto',
    left: 'auto',
    margin: 0,
  };

  return (
    <div style={timeStyles}>
      {!forTutorManager && (
        <>
          <h6 style={{ margin: '2px 0', fontSize: '14px', color: 'white' }}>
            Date: {currentTimeStr.date}
          </h6>
          <h6 style={{ margin: '2px 0', fontSize: '14px', color: 'white' }}>
            Time: {currentTimeStr.time}
          </h6>
        </>
      )}
    </div>
  );
}
